export default __webpack_public_path__ + "static/media/citation-close.d5b2b3ab.svg";